import {
  postJsonAsync,
  getJsonAsync
} from 'shared/actions';
import {
  displayTeamAudit,
  displayTeamAuditHeader,
  displayTeamAuditDetails
} from './actionTypes';

export const handleTeamSearch = () => (dispatch, getState) => {
  let searchValue = getState().admin.entryAudit.searchEntryAuditValue;

  if (searchValue && searchValue.length > 0) searchValue = searchValue.toLowerCase();

  if (searchValue && searchValue.trim().length > 2)
  {
    dispatch(postJsonAsync(`audit/teamAudit`, {searchFilter: searchValue}))
    .then(data => {
      dispatch(displayTeamAudit(data));
    })
    .catch(() => { });
  }
};

export const loadEntryAudit = (entryId) => (dispatch) => {
  
  dispatch(getJsonAsync(`audit/teamAudit/${entryId}`))
    .then(data => {
      dispatch(displayTeamAuditHeader(data));
    })
    .catch(() => { }); 
  
  dispatch(getJsonAsync(`audit/teamAuditDetails/${entryId}`))
    .then(data => {
      dispatch(displayTeamAuditDetails(data));
    })
    .catch(() => { }); 
};
  
export const handleTeamSearchEnterKeyPress = event => dispatch => {
  if (event.keyCode === 13) {
    event.preventDefault();
    event.stopPropagation();
    dispatch(handleTeamSearch());
  }
};


// WEBPACK FOOTER //
// ./src/features/admin/audit/entryAudit/actions.js